<template>
    <v-dialog v-model="dialogFSC" max-width="1150px" persistent @keydown.esc="chiudiDialogFSC">
        <v-container style="background-color: white;" fluid>
            <v-row class="ma-0 pa-0">
                <v-btn icon @click="caricaDati">
                    <v-icon>refresh</v-icon>
                </v-btn>
                <v-btn color="success" @click="apriDialogItem()" small class="mt-1 ml-2">
                    <v-icon left>add</v-icon> Aggiungi gruppo di prodotto
                </v-btn>
                <v-spacer />
                <v-btn icon @click="chiudiDialogFSC">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-row>

            <v-text-field v-model="search" append-icon="search" label="Cerca..." class="mt-2 mb-2" solo clearable />

            <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1" hide-default-footer
                :items-per-page="-1" fixed-header height="60vh" dense no-data-text="Nessun dato disponibile">
                <template v-slot:item.actions="{ item }" class="pl-0 pr-0 ml-0 mr-0">
                    <v-btn icon color="primary" @click="apriDialogItem(item)">
                        <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="duplicaElemento(item)">
                        <v-icon>content_copy</v-icon>
                    </v-btn>
                    <v-btn icon color="primary" @click="eliminaElemento(item)">
                        <v-icon>delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ editedItem.idGruppo != "-1" ? 'Modifica' : 'Aggiungi' }}
                            gruppo di prodotto </span>
                    </v-card-title>

                    <v-card-text>
                        <v-form ref="form">
                            <v-text-field v-model="editedItem.codGruppo" label="Codice Gruppo" required />
                            <v-text-field v-model="editedItem.descrizione" label="Descrizione" required />
                            <v-text-field v-model="editedItem.traduzione" label="Traduzione" required />
                            <v-select v-model="editedItem.inputOutput" label="Input/Output" :items="['I', 'O']"
                                required />
                        </v-form>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn @click="chiudiDialogItem">Annulla</v-btn>
                        <v-btn color="primary" @click="salvaElemento">Salva</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </v-dialog>
</template>

<script>
import { get_gruppi_prodotto, post_gruppo_prodotto, del_gruppo_prodotto } from '@/api/api.registroSintesi.js'

export default {
    props: {
        dialogFSC: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
    },

    data() {
        return {
            dialog: false,
            search: '',
            items: [],
            editedItem: {
                idGruppo: null,
                codGruppo: '',
                descrizione: '',
                traduzione: '',
                inputOutput: 'I',
            },
            headers: [
                { text: 'ID', value: 'idGruppo' },
                { text: 'Codice', value: 'codGruppo' },
                { text: 'descrizione', value: 'descrizione' },
                { text: 'traduzione', value: 'traduzione' },
                { text: 'tipologia', value: 'inputOutput', class: 'ml-0 pl-0 mr-0 pr-0' },
                { text: 'Azioni', value: 'actions', class: 'ml-0 pl-0 mr-0 pr-0', sortable: false }
            ]
        }
    },
    methods: {
        async caricaDati() {
            let par = ""
            if (this.role === "admin")
                par = "?companyCode=" + this.compCode;
            let res = await get_gruppi_prodotto(par);
            this.items = res.data;
        },

        apriDialogItem(item = null) {
            this.editedItem = item ? { ...item } : { companyCode: this.compCode, idGruppo: -1, codGruppo: '', descrizione: '', traduzione: '', inputOutput: 'I' }
            this.dialog = true
        },

        duplicaElemento(item) {
            this.editedItem = { ...item };
            this.editedItem.idGruppo = -1;
            this.editedItem.codGruppo = "";
            this.dialog = true;
        },

        chiudiDialogItem() {
            this.dialog = false
        },

        async salvaElemento() {
            if (!this.editedItem.descrizione || !this.editedItem.codGruppo || !this.editedItem.traduzione || !this.editedItem.inputOutput) return;
            let res = await post_gruppo_prodotto(this.editedItem)
            if (res.data === "OK") {
                this.caricaDati()
                this.dialog = false
            } else {
                this.$toast.error("Errore. " + res.data)
            }
        },

        chiudiDialogFSC() {
            this.$emit('close')
        },

        async eliminaElemento(item) {
            let confirm = await this.$confirm.open("Elimina", "Eliminare il gruppo <b>" + item.descrizione + "</b>?");
            if (!confirm) return;
            let res = await del_gruppo_prodotto(item);
            if (res.data === "OK") this.caricaDati();
        },

    },

    watch: {
        dialogFSC(newVal) {
            if (newVal) this.caricaDati();
        }
    },

    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        },
    },
}
</script>
